import {type MouseEvent, useCallback, useEffect, useState} from 'react';
import type {NativeSyntheticEvent, NativeTouchEvent} from 'react-native';

import type {CheckboxV2} from './Checkbox.v2';

import MinusSVG from '../../../assets/icons/minus.svg';
import {createEventNormalizer} from '../../../utils/events';
import CheckSVG from '../assets/check.svg';

export const useCheckboxV2Controller = ({
  checked: checkedProp,
  controlled,
  disabled,
  indeterminate,
  onClick,
}: CheckboxV2.Props) => {
  const [checked, setChecked] = useState(checkedProp);

  useEffect(() => {
    if (!controlled) {
      setChecked(checkedProp);
    }
  }, [checkedProp, controlled]);

  const getSvg = () => {
    switch (true) {
      case indeterminate:
        return MinusSVG;
      case checked && !indeterminate:
      default:
        return CheckSVG;
    }
  };
  const clickHandler = useCallback(
    (event: any) => {
      if (disabled) {
        return;
      }

      const newValue = controlled ? !checked : checkedProp;

      const normalized = eventNormalizer(event, {checked: Boolean(newValue)});

      onClick?.(normalized);

      setChecked(newValue);
    },
    [checked, checkedProp, controlled, disabled, onClick],
  );

  return {checked, CheckSvg: getSvg(), clickHandler};
};

const eventNormalizer = createEventNormalizer<
  MouseEvent,
  NativeSyntheticEvent<NativeTouchEvent>,
  CheckboxV2.ClickEventPayload
>();
